import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { SearchTableState } from "../search-table-state";
import { BaseService } from "../base.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class TransactionLogService extends BaseService {

    private static searchUrl: string = '/api/transactionlogs/search';
    private static exportExcelUrl: string = '/api/transactionlogs/exportExcel';
    private static downloadExcelUrl: string = '/api/transactionlogs/downloadExcel';
    public searchTableState: SearchTableState = null;

    constructor(
        private http: HttpClient
    ) {
        super();
        this.searchTableState = new SearchTableState();
        this.searchTableState.propertyName = 'CreateDateUTC';
    }

    refreshTableState() {
        this.searchTableState = new SearchTableState();
    }

    private searchTableStateCopy(): any {
        let copy: any = Object.assign({}, this.searchTableState);
        /* Disable refresh search */
        copy.lastRefreshed = new Date();
        if (copy.lastRefreshed) {
            copy.lastRefreshed = new Date(copy.lastRefreshed.getTime() + -1 * (new Date().getTimezoneOffset() * 60000));
        }
        this.updateFilterField(copy, 'mobileNumber', 'mobileNumberCondition');
        this.updateFilterField(copy, 'loyaltyTransactionLogId', 'loyaltyTransactionLogIdCondition');
        this.updateFilterField(copy, 'siteName', 'siteNameCondition');
        return copy;
    }

    public searchTransactionLogs(): Observable<any> {
        let copy = this.searchTableStateCopy();
        return this.http.post<any>(TransactionLogService.searchUrl, copy);
    }

    public exportExcel(): Observable<any> {
        let copy = this.searchTableStateCopy();
        return this.http.post<any>(TransactionLogService.exportExcelUrl, copy, {responseType: 'blob' as 'json'});
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/transaction-log/transaction-log-management.service.ts